"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabFocusTrap = TabFocusTrap;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["className", "children"];
var styles = {
  "TabFocusTrap": "TabFocusTrap__TabFocusTrap___39Vty"
};

function TabFocusTrap(_ref) {
  var className = _ref.className,
      children = _ref.children,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classNames = (0, _classnames["default"])(styles.TabFocusTrap, className);
  return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
    tabIndex: -1,
    className: classNames
  }, otherProps), children);
}